import template from './FilterItem.html';

export default {
	template,
	props: ['filter-key', 'should-translate', 'open'],
	computed: {
		item() {
			let item = this.filtersMap[this.filterKey];
			return {...item, open: !!this.open};
		}
	},
	methods: {
		getChbTrueValue(items) {
			if (items.trueValue === void 0) return 1;
			if (items.trueValue === null) return void 0;
			return items.trueValue;
		},
		getChbFalseValue(items) {
			if (items.falseValue === void 0 || items.falseValue === null) return void 0;
			return items.falseValue;
		},
		onItemsChanged(e, item) {
			if (typeof item.onChange === 'function') {
				return item.onChange(e);
			}

			this.refreshQuery(e);

			this.$emit('change', e);
		}
	}
}